import { IRevisionService  } from './revision.types'
import { http } from '@/shared/https'

export class RevisionService implements IRevisionService {
    
    // return to lead partner
    returnToLP(workflowInfo: any) {
        return http.post('api/Revision', workflowInfo)
        .then((resp) => {
            return resp;
        })
    }

    // submit back the returned application
    submit(workflowInfo: any) {
        return http.post('api/Revision/Submit', workflowInfo)
        .then((resp) => {
            return resp;
        })
    }

    // validate on submit
    validateOnSubmit(transactionId: number, workflowStepId: number, entity: any) {
        return http.post(`api/Revision/Validate/${transactionId}/Workflow/${workflowStepId}`, entity)
        .then((resp) => {
            return resp;
        });
    }
}